import React from 'react';
import GameHeader from './game-header';
import { global_var } from '../../services/cs-lab-config';

const WebTypist = () => {

  document.title = "CS Lab | WebTypist";

  return (
    <div className="container-fluid p-0">
      <div className="row mt-1">
        <div className="col">
          <GameHeader headerName="CS Typing Tutor" />
          <iframe
            id="webTypistIframe"
            src={global_var.WEB_TYPIST_ENDPOINT }
            title="CS Typing Tutor"
            style={{
              width: '100%',
              height: '90vh',
              border: 'none',
            }}
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default WebTypist;
